import type { ReactNode } from "react";
import { ArrowDown2 } from "iconsax-reactjs";
import Dropdown, {
  DropdownOption,
} from "../../commons/DataTableDropdown";

type Props = {
  value: string;
  placeholder: string;
  options: DropdownOption<string>[];
  icon: ReactNode;
  disabled?: boolean;
  onChange: (value: string) => void;
  className?: string;
};

export default function ChallengeHeaderFilter({
  value,
  placeholder,
  options,
  icon,
  disabled,
  onChange,
  className,
}: Props) {
  return (
    <div className={`h-10 w-36 ${className ?? ""}`}>
      <Dropdown<string>
        options={[{ value: "", label: placeholder }, ...options]}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        className="h-full w-full"
        menuWidth="180px"
        renderButton={(option, isOpen, buttonRef, toggleOpen) => (
          <button
            ref={buttonRef}
            type="button"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation();
              toggleOpen();
            }}
            className="flex h-10 w-full items-center gap-2 rounded-lg border border-gray-300 px-3 text-sm transition-colors hover:bg-gray-50 focus:border-primaryVar-500 disabled:cursor-not-allowed disabled:bg-gray-50"
          >
            <span className="shrink-0 text-gray-400">{icon}</span>
            <span
              className={`flex-1 truncate text-right ${
                option && option.value !== ""
                  ? "text-gray-800"
                  : "text-gray-400"
              }`}
            >
              {option && option.value !== "" ? option.label : placeholder}
            </span>
            <ArrowDown2
              size={16}
              className={`shrink-0 text-gray-400 transition-transform duration-200 ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </button>
        )}
      />
    </div>
  );
}
